import { createAction } from "@reduxjs/toolkit";

export const ACTION_TYPES = {
  ISQ_SELECT_OPTION: "ISQ_SELECT_OPTION",
  ISQ_UNSELECT_OPTION: "ISQ_UNSELECT_OPTION",
  ISQ_SUBMIT: "ISQ_SUBMIT",
  ISQ_RESET: "ISQ_RESET",
};

export const isqSelectOption = createAction(
  ACTION_TYPES.ISQ_SELECT_OPTION,
  (payload) => ({ payload })
);

export const isqUnselectOption = createAction(
  ACTION_TYPES.ISQ_UNSELECT_OPTION,
  (payload) => ({ payload })
);

export const isqReset = createAction(ACTION_TYPES.ISQ_RESET, (payload) => ({
  payload,
}));

export const isqSubmit = createAction(ACTION_TYPES.ISQ_SUBMIT, (payload) => ({
  payload,
}));
